import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { SPRITE_MANIFEST } from '../../../icon-sprite-manifest';

@Injectable({
    providedIn: 'root',
})
export class IconService {
    private matIconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    registerIcons(): void {
        try {
            const { filename, hash } = SPRITE_MANIFEST;
            const spriteUrl = `assets/${filename}?${hash}`;

            this.matIconRegistry.addSvgIconSet(this.sanitizer.bypassSecurityTrustResourceUrl(spriteUrl));
        } catch (error) {
            console.warn('Failed to register icons, falling back to default sprite name:', error);
            this.matIconRegistry.addSvgIconSet(this.sanitizer.bypassSecurityTrustResourceUrl('assets/icon-sprite.svg'));
        }
    }
}
